import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import Service from '@/features/reports/service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_REPORTS = 'UPDATE_REPORTS';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const UPDATE_EMPLOYEES = 'UPDATE_EMPLOYEES';
export const initModuleAction = 'initModuleAction';
export const updateReportsAction = 'updateReportsAction';

export default {
  namespaced: true,
  state: {
    searchingReports: false,
    report: {
      pr_comercial: '',
      pr_juridico: '',
      pr_financiero: '',
      pr_final: '',
      id: '',
    },
    prereport: {
      pr_comercial: '',
      pr_juridico: '',
      pr_financiero: '',
      pr_final: '',
      id: '',
    },
    error: '',
    employees: [],
    operation: {},
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'report', {
        pr_comercial: '',
        pr_juridico: '',
        pr_financiero: '',
        pr_final: '',
        id: '',
      });
      Vue.set(state, 'error', '');
      Vue.set(state, 'employees', []);
    },
    [UPDATE_ERROR](state, msg) {
      Vue.set(state, 'error', msg);
    },
    [UPDATE_REPORTS](state, payload) {
      const strIdentifier = '\n -- Valoraciones -- \n';
      Vue.set(state, 'report', payload);
      if (state.prereport.pr_comercial && state.prereport.pr_comercial.length > 0) {
        if (state.report.pr_comercial && state.report.pr_comercial.length) {
          state.report.pr_comercial = state.prereport.pr_comercial + strIdentifier + state.report.pr_comercial;
        } else {
          state.report.pr_comercial = state.prereport.pr_comercial + strIdentifier;
        }
      }
      if (state.prereport.pr_financiero && state.prereport.pr_financiero.length > 0) {
        if (state.report.pr_financiero && state.report.pr_financiero.length) {
          state.report.pr_financiero = state.prereport.pr_financiero + strIdentifier + state.report.pr_financiero;
        } else {
          state.report.pr_financiero = state.prereport.pr_financiero + strIdentifier;
        }
      }
      if (state.prereport.pr_juridico && state.prereport.pr_juridico.length > 0) {
        if (state.report.pr_juridico && state.report.pr_juridico.length) {
          state.report.pr_juridico = state.prereport.pr_juridico + strIdentifier + state.report.pr_juridico;
        } else {
          state.report.pr_juridico = state.prereport.pr_juridico + strIdentifier;
        }
      }
    },
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [UPDATE_EMPLOYEES](state, payload) {
      payload.forEach((e) => {
        state.employees.push(e.attributes.title);
      });
    },
  },
  actions: {
    async [initModuleAction]({ commit, dispatch }, payload) {
      // const { operation } = payload;
      commit(CLEAR_MODULE);
      startLoading(dispatch, 'financiero');
      await dispatch('propuestano/initModuleAction', payload, { root: true });
      await dispatch('expenses_model/fetchAction', {}, { root: true });
      endLoading(dispatch, 'financiero');
      // commit(UPDATE_OPERATION, operation);
      // commit(UPDATE_EMPLOYEES, []);
    },
    [updateReportsAction]({ commit, state, dispatch }, payload) {
      let preReportData = {};
      let promise = null;
      let msg = '';
      let today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      today = `${dd}/${mm}/${yyyy}`;
      switch (payload.$event.title) {
        case 'Analista Comercial':
          if (state.report.pr_comercial && state.report.pr_comercial.length) {
            msg = `${state.report.pr_comercial}\n`;
          }
          break;
        case 'Analista Juridico':
          if (state.report.pr_juridico && state.report.pr_juridico.length) {
            msg = `${state.report.pr_juridico}\n`;
          }
          break;
        case 'Responsable Financiero':
          if (state.report.pr_financiero && state.report.pr_financiero) {
            msg = `${state.report.pr_financiero}\n`;
          }
          break;
        default:
          msg = '';
      }

      if (payload.$event.option === 'Aprobado') {
        msg += `[${today} - ${payload.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Aprobado') {
        msg += `[${today} - ${payload.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.option === 'Denegado') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Denegado') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.option === 'Condicionar') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Condicionar') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      }
      if (payload.$event.title === 'Analista Comercial') {
        preReportData = {
          pr_comercial: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Analista Juridico') {
        preReportData = {
          pr_juridico: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Responsable Financiero') {
        preReportData = {
          pr_financiero: msg,
          id: payload.id,
        };
      }
      promise = Service.updateReport(preReportData);
      return promise
        .then(newData => commit(UPDATE_REPORTS, newData));
    },
  },
  getters: {
    employees: state => state.employees,
    report: state => state.report,
  },
};



// WEBPACK FOOTER //
// ./src/features/financiero/store.js